import { AuthContent } from '../../components';
import styles from './AuthPage.module.scss';
import SvgIcon from '../../assets/icons';

const AuthPage = ({ logIn }: { logIn: () => void }) => {
  return (
    <div className={styles.authWrapper}>
      <div className={styles.auth__content}>
        <SvgIcon name="logo" width="120" height="20" />
        <AuthContent logIn={logIn} />
      </div>

      <div className={styles.auth__bg}></div>
    </div>
  );
};

export default AuthPage;
